// extracted by mini-css-extract-plugin
export default {"app":"App-module__app___OFBt5"};